<script lang="ts" setup>
import { inject, ref } from 'vue'

import { radioGroupValueChangedKey, radioGroupPropsKey } from '@/types/inputs'

export interface Props {
    value: string | number | boolean | undefined
    label: string
    small?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    small: false,
})

const focused = ref(false)

const radioData = inject(radioGroupPropsKey)
const valueChanged = inject(radioGroupValueChangedKey)

function onChange() {
    if (valueChanged) valueChanged(props.value)
}
</script>

<template>
    <div
        class="relative flex w-full cursor-pointer select-none justify-center items-center border-r border-t border-b border-green-500 py-1 transition-colors first:rounded-l-lg first:border-l last:rounded-r-lg"
        :class="{
            'bg-green-500 text-white': radioData?.modelValue === props.value,
            'ring-2 ring-inset ring-green-400': focused,
            'text-xs px-2': props.small,
            'px-5': !props.small,
        }"
    >
        <input
            class="absolute left-0 top-0 h-full w-full cursor-pointer rounded-none opacity-0"
            type="radio"
            :value="props.value"
            :name="radioData?.name ?? radioData?.id"
            :disabled="radioData?.disabled"
            @focus="focused = true"
            @blur="focused = false"
            @change="onChange"
        />

        {{ props.label }}
    </div>
</template>
